import { render, staticRenderFns } from "./PerguntasFormularioDialog.vue?vue&type=template&id=8f01311c&"
import script from "./PerguntasFormularioDialog.vue?vue&type=script&lang=js&"
export * from "./PerguntasFormularioDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PerguntasFormularioDialog.vue"
export default component.exports